// extracted by mini-css-extract-plugin
export default {"langAbsolute":"LangAbdolute_langAbsolute__AZhFO","langAbsolute_block":"LangAbdolute_langAbsolute_block__aj-oa","langChange":"LangAbdolute_langChange__21DdM"};